import React, { useContext, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import moment from "moment";
import { StyledContainer, StyledHeader } from "./History.styles";
import { Grid } from "@mui/material";
import Timeline, { MeasurementProp } from "components/shared/Timeline/Timeline";
import Measurements from "./Measurements/Measurements";
import API from "api";
import Session from "helpers/session";
import { formatReading } from "helpers/variables";
import { GlobalContext } from "context/Provider";
import { ReadingContextInterface } from "context/initialState/Readings";
import { useTranslation } from "react-i18next";

const formatTimeline = (rawReadings: MeasurementProp[]) => {
  const timelineObj: Record<string, MeasurementProp[]> = {};
  const timelineArray: MeasurementProp[][] = [];

  rawReadings.forEach((reading) => {
    const key = moment(`${reading.date.split(",")[0]}, ${reading.year} ${reading.date.split(",")[1]}`).format(
      "MM/DD/YYYY"
    );
    if (!timelineObj[key]) timelineObj[key] = [];
    timelineObj[key].push(reading);
  });

  Object.values(timelineObj).forEach((line) => timelineArray.push(line));

  return timelineArray;
};

const TimeLineView: React.FC<{ timeline: MeasurementProp[][] }> = ({ timeline }) => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledHeader>
        <h2>{t("u-timeline")}</h2>
      </StyledHeader>
      <Grid container>
        <Grid item xs={0.2} />
        <Grid item xs={11.4}></Grid>
      </Grid>
      <Grid container>
        <Grid item xs={1} />
        <Grid item xs={10}>
          {timeline.map((line, index) => (
            <Timeline
              key={`timeline-component-${line[0].id}-${index}`}
              date={line[0].date}
              measurements={line}
              year={line[0].year || ""}
            />
          ))}
        </Grid>
        <Grid item xs={1} />
      </Grid>
    </StyledContainer>
  );
};

export default function History() {
  const [timeline, setTimeline] = useState<MeasurementProp[][]>([]);
  const { memberDispatch } = useContext(GlobalContext);
  const memberId = window.location.pathname.split("/").pop();

  useEffect(() => {
    API.kore.readings
      .getForOne(memberId || "", Session.crackCookieToken("coordinator"))
      .then((readings) => {
        memberDispatch({ type: "UPDATE_CID", payload: readings.cid });
        const processedReadings = readings.items.map((line: ReadingContextInterface) =>
          formatReading(line)
        );
        const sortedReadings = formatTimeline(processedReadings).sort(
          (a, b) => moment(`${a[0].date}, ${a[0].year}`).unix() - moment(`${b[0].date}, ${b[0].year}`).unix()
        );
        setTimeline(sortedReadings.reverse());
      });
  }, [memberDispatch, memberId]);

  return (
    <Routes>
      <Route path="timeline/:memberId" element={<TimeLineView timeline={timeline} />} />
      <Route
        path="bloodpressure/*"
        element={<Measurements type="Blood Pressure"/>}
      />
      <Route
        path="bloodglucose/*"
        element={<Measurements type="Blood Glucose"/>}
      />
      <Route path="heartrate/*" element={<Measurements type="Heart Rate"/>} />
      <Route
        path="oxygensaturation/*"
        element={<Measurements type="Oxygen Saturation"/>}
      />
      <Route
        path="temperature/*"
        element={<Measurements type="Temperature"/>}
      />
      <Route path="weight/*" element={<Measurements type="Weight"/>} />
      <Route path="activity/*" element={<Measurements type="activity"/>} />
      <Route path="sleep/*" element={<Measurements type="Sleep"/>} />
      <Route path="spirometry/*" element={<Measurements type="Spirometry"/>} />
      <Route
        path="respirationrate/*"
        element={<Measurements type="Respiration Rate"/>}
      />
      <Route
        path="membernote/*"
        element={<Measurements type="Member Note"/>}
      />
    </Routes>
  );
}
